import messageStep from './MessageStep/index';
import transition from './Transition/index';
import trigger from './Trigger/index';
import validation from './Validation/index';
import automatedStep from './AutomatedStep/index';

const types = { messageStep, transition, trigger, validation, automatedStep };

export default types;
